import classNames from 'classnames';
import React from 'react';

import { SelectPanelListProps } from '.';
import { SelectPanelItem } from './SelectPanelItem';

import './SelectPanelList.scss';

function SelectPanelList({ className, children, ...rest }: SelectPanelListProps) {
    return (
        <ul className={classNames('select-panel-list', className)} {...rest}>
            {children}
        </ul>
    );
}

SelectPanelList.Item = SelectPanelItem;

export default SelectPanelList;
